import { useLoaderData, useRouteLoaderData } from '@shared/lib/routing';
import { Breadcrumbs } from '@shared/ui/breadcrumbs';
import { CatalogGrid } from '@shared/ui/catalog-grid';
import { PageContainer } from '@shared/ui/content-containers';
import { PageTitle } from '@shared/ui/titles';
import { PageBanner, PageCustomText, PageHelmet } from '@widgets/seoPage';
import SubscribeForm from 'frontend/Components/Modals/SubscribeModal/SubscribeForm';
import { useTranslation } from 'react-i18next';
import { Preloader } from '@shared/ui/preloader';
import { promotionsPageLoader } from '../api';
import { PromotionCard } from './Promotion';

export function Promotions() {
  const { pageData, loading } =
    useLoaderData<Awaited<ReturnType<typeof promotionsPageLoader>>>();
  const {
    country: { main_domain: mainDomain },
    city: { city_name: cityName, stocks_subscribe_block: subscribeBlock },
  } = useRouteLoaderData('city-layout');
  const { t } = useTranslation();

  if (loading) return <Preloader />;

  const { seoPageData, promotions, categories } = pageData;

  const pageName = t('localization.Stocks');

  return (
    <>
      <PageBanner bannerData={seoPageData.banner} mainDomain={mainDomain} />
      <PageHelmet
        cityName={cityName}
        mainDomain={mainDomain}
        seo={seoPageData.seo}
        type="article"
        title={pageName}
        ogTitle={pageName}
      />
      <PageContainer>
        <Breadcrumbs links={[{ text: pageName }]} />
        <PageTitle isCenterOnMobile>{pageName}</PageTitle>
        {promotions.length > 0 && (
          <CatalogGrid maxInRow="3">
            {promotions.map((promo) => {
              const { name } =
                categories.find(({ id }) => id === promo.category_id) || {};
              return (
                <PromotionCard
                  key={promo.id}
                  item={promo}
                  mainDomain={mainDomain}
                  categoryName={name}
                />
              );
            })}
          </CatalogGrid>
        )}
        {subscribeBlock && <SubscribeForm blockView />}
        <PageCustomText
          customText={seoPageData.seo.custom_text}
          mainDomain={mainDomain}
        />
      </PageContainer>
    </>
  );
}
